import {
  clearPendingSession,
  readPendingSession,
  storePendingSession,
} from "../pending-session";
import { parsePaymentReturn, paymentSessionIdFromQuery } from "../return-status";
import { PaymentProviderName } from "@/lib/config";
import type {
  PaymentConfirmation,
  PaymentProvider,
  PaymentSession,
  ReturnContext,
} from "../types";

/**
 * Development provider with no real PSP. Simulates a successful redirect back
 * to the return URL so the full two-phase flow can be exercised locally.
 */
export class MockPaymentProvider implements PaymentProvider {
  readonly name = PaymentProviderName.Mock;

  async startCheckout(session: PaymentSession): Promise<void> {
    storePendingSession({
      paymentSessionId: session.paymentSessionId ?? session.sessionId,
      providerSessionId: session.sessionId,
      provider: this.name,
      orderReference: session.orderReference,
    });
    const url = new URL(session.returnUrl);
    url.searchParams.set("status", "AUTHORISED");
    url.searchParams.set("resultCode", "Authorised");
    if (session.orderReference) {
      url.searchParams.set("merchantReference", session.orderReference);
    }
    window.location.assign(url.toString());
  }

  parseReturn(ctx: ReturnContext): PaymentConfirmation {
    const pending = readPendingSession();
    const parsed = parsePaymentReturn(ctx.query);
    clearPendingSession();
    return {
      sessionId: pending?.paymentSessionId ?? paymentSessionIdFromQuery(ctx.query) ?? "",
      paymentProviderSessionId:
        pending?.providerSessionId ?? paymentSessionIdFromQuery(ctx.query),
      provider: this.name,
      outcome: parsed.outcome,
      orderReference: parsed.orderReference ?? pending?.orderReference,
      resultCode: parsed.resultCode,
      providerData: { ...ctx.query },
    };
  }
}
